export const THEMES = {
  dark: {
    bg:           "#080c14",
    sidebar:      "#0d1220",
    surface:      "#111827",
    surface2:     "#1a2235",
    border:       "rgba(255,255,255,0.07)",
    border2:      "rgba(255,255,255,0.12)",
    text:         "#f1f5f9",
    textSub:      "#94a3b8",
    textFaint:    "#475569",
    accent:       "#3b82f6",
    accentBg:     "rgba(59,130,246,0.12)",
    accentBorder: "rgba(59,130,246,0.3)",
    green:        "#22c55e",
    greenBg:      "rgba(34,197,94,0.12)",
    amber:        "#f59e0b",
    amberBg:      "rgba(245,158,11,0.12)",
    red:          "#ef4444",
    redBg:        "rgba(239,68,68,0.12)",
    purple:       "#a78bfa",
    purpleBg:     "rgba(167,139,250,0.12)",
    shadow:       "0 4px 20px rgba(0,0,0,0.4)",
    shadowSm:     "0 2px 8px rgba(0,0,0,0.25)",
    chartGrid:    "rgba(255,255,255,0.05)",
  },
  light: {
    bg:           "#eef2f8",
    sidebar:      "#ffffff",
    surface:      "#ffffff",
    surface2:     "#f4f7fc",
    border:       "rgba(0,0,0,0.08)",
    border2:      "rgba(0,0,0,0.14)",
    text:         "#0f172a",
    textSub:      "#64748b",
    textFaint:    "#94a3b8",
    accent:       "#2563eb",
    accentBg:     "rgba(37,99,235,0.08)",
    accentBorder: "rgba(37,99,235,0.25)",
    green:        "#16a34a",
    greenBg:      "rgba(22,163,74,0.1)",
    amber:        "#d97706",
    amberBg:      "rgba(217,119,6,0.1)",
    red:          "#dc2626",
    redBg:        "rgba(220,38,38,0.1)",
    purple:       "#7c3aed",
    purpleBg:     "rgba(124,58,237,0.1)",
    shadow:       "0 4px 16px rgba(0,0,0,0.08)",
    shadowSm:     "0 1px 4px rgba(0,0,0,0.06)",
    chartGrid:    "rgba(0,0,0,0.06)",
  },
};
